export default __webpack_public_path__ + "static/media/Directory.817379e4.svg";